/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';

import styles from '../../styles';

const Input = styled.input`
  background-color: white;
  color: ${styles.colors.biscay};
  border: 1px solid ${styles.colors.avatar};
  border-radius: 0.25rem;
  width: 100%;
  transition: border 0.1s linear, background-color 0.1s linear;
  display: inline-block;
  padding: 0 0.5rem;
  line-height: 1.875rem;
  min-height: calc(1.875rem + (1px * 2));
`;

export default Input;
